import { render, staticRenderFns } from "./LaudoSupressaoVegetalModal.vue?vue&type=template&id=fe2c6a88&scoped=true&lang=pug"
import script from "./LaudoSupressaoVegetalModal.vue?vue&type=script&lang=js"
export * from "./LaudoSupressaoVegetalModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoSupressaoVegetalModal.vue?vue&type=style&index=0&id=fe2c6a88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2c6a88",
  null
  
)

export default component.exports